import { useMutation, useQueryClient } from "@tanstack/vue-query";
import ParentTemplateFolder from "@/services/template/parent-template-folder";
import type { RegisterParentTemplateFolder } from "@/dtos/ParentTemplateFolder.dto";

export function useCreateParentTemplateFolder() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: RegisterParentTemplateFolder) => {
      const response = await ParentTemplateFolder.registerParentTemplateFolder(data);

      if (response.data.status) {
        return response.data.data;
      }

      throw new Error(response.data.msg || "Failed to create parent template folder");
    },
    onSuccess: () => {
      // Invalidate parent template folders query to refetch
      queryClient.invalidateQueries({ queryKey: ["parentTemplateFolders"] });
    },
  });
}
